<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>

                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>نام</label>
                                    <input type="text" name="title" v-model="info.title" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>زمان هر سانس  </label>
                                    <input type="text" name="duration_hour" v-model="info.duration_hour" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-6 ">
                                <div class="form-group">
                                    <label style="margin-bottom:10px;"> تاریخ سمینار </label>
                                    <date-picker v-model="info.start_date"></date-picker>

                                </div>
                            </div>

                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label class="sr-only" for="inline-form-input-name">
                                        منطقه برگزاری</label>
                                    <a-tree-select v-model="info.city_id" show-search style="width: 100%"
                                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                        placeholder="انتخاب استان و شهر  " allow-clear tree-default-expand-all>
                                        <a-icon slot="suffixIcon" type="smile" />
                                        <a-tree-select-node v-for="state in states" :key="'state' + state.id"
                                            :value="'state' + state.id" :title="state.name" :disabled="true">
                                            <a-tree-select-node v-for="city in state.cities" :key="city.id"
                                                :value="city.id" :title="city.name"/>
                                            

                                        </a-tree-select-node>


                                    </a-tree-select>
                                </div>
                            </div>
                            <div class="col-md-12 my-5">
                                <div class="form-group ">
                                    <label>محل برگزاری</label>
                                    <b-form-textarea name="description" id="textarea" v-model="info.description" placeholder=" ..."
                                        rows="3" max-rows="6"></b-form-textarea>
                                </div>

                            </div>

                            <hr class="mt-5">


                            


                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                              
                                <div class="col-md-1 ">
                                    <router-link to="/seminars/list" class="btn btn-fill btn-outline-danger w-100">
                                        بازگشت</router-link>
                                </div>

                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    import PictureInput from 'vue-picture-input';

    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

    export default {
        components: {
            PictureInput,
            datePicker: VuePersianDatetimePicker

        },
        data() {
            return {
                info: {
                },
                states: [],
              
            };
        },
        mounted() {
         this.getStates();
        },
        methods: {
           
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append('start_date',this.info.start_date);
                data.append('city_id',this.info.city_id);
                _this.$root.loading = true;

                axios
                    .post("/seminars/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success(" سمینار با موفقیت افزوده شد");
                        _this.$router.push("/seminars/list");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getStates() {
                let _this = this;
                let url = '/products/states';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.states = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
    };
</script>
